import { subdomains } from "@/common/consts";
import { getCurrentSubdomain } from "@/common/functions";

let subdomain = getCurrentSubdomain();

const filters = [
    { label: "itemDictionary", value: subdomains.DEFINITIONS },
    { label: "itemThesaurus", value: subdomains.THESAURUS },
    { label: "itemExamples", value: subdomains.EXAMPLES },
    { label: "itemSentences", value: subdomains.SENTENCES },
    { label: "itemQuotes", value: subdomains.QUOTES },
    { label: "itemReference", value: subdomains.REFERENCE },
    { label: "itemWordFinder", value: subdomains.WORDFINDER }
];

switch (subdomain) {
    case subdomains.ES:
        filters[3].label = "Es";
        filters[3].value = subdomains.ES;
        break;
    case subdomains.ABBREVIATIONS:
        filters[5].value = subdomains.ABBREVIATIONS;
        break;
    case subdomains.ESL:
        filters[5].value = subdomains.ESL;
        break;
    case subdomains.GRAMMAR:
        filters[5].value = subdomains.GRAMMAR;
        break;
    case subdomains.EDUCATION:
        filters[5].value = subdomains.EDUCATION;
        break;
    case subdomains.EXAMPLES:
        filters[2].value = subdomains.EXAMPLES;
        break;
    default:
        filters[3].label = "itemSentences";
        filters[3].value = subdomains.SENTENCES;
        filters[5].value = subdomains.REFERENCE;
}

export default filters;



// WEBPACK FOOTER //
// ./src/components/Search/filters.js